<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
	<path class="color-solid" d="M12,4.47l7.65,5.55L16.73,19H7.27l-2.92-8.98L12,4.47 M12,2L2,9.26L5.82,21h12.36L22,9.26L12,2L12,2z" />
	<polygon class="color-vector" points="12,6.32 6.12,10.6 8.36,17.5 15.64,17.5 17.88,10.6" />
</svg>
</template>